import { Component } from 'react';
import { apiPost, showLoader, hideLoader, handleApiError } from '../../../../common';
import AssetPickerEditOption from './asset-picker-edit-option';

class AssetPickerCopyFolderOption extends Component {
  render() {
    return (
      <div className="asset-picker-edit-option">
        <AssetPickerEditOption
          title="Copy folder"
          src="/images/new_ui_copy_icon.svg"
          height="75%"
          onClick={this.handleCopyFolderClick}
        />
      </div>
    );
  }

  handleCopyFolderClick = (e) => {
    e.preventDefault();
    const me = this;
    const cont = confirm('Are you sure you want to copy this folder?');

    if (cont) {
      showLoader();
      apiPost(
        `item_folders` + `/${this.props.folder.id}/copy`,
        null,
        () => {
          hideLoader();
          me.props.updateCallback();
        },
        handleApiError(),
      );
    }
  };
}

export default AssetPickerCopyFolderOption;
